import { useState } from 'react';
import styles from './Settings.module.css';
import AIEduButton from '../../components/Button/AIEduButton';
import AIEduRadioButton from '../../components/RadioButton/AIEduRadioButton';
import AIEduSwitch from '../../components/Switch/AIEduSwitch';
import { ROLE_ADMIN, ROLE_USER } from '../../utils/Constants';
import AIEduTooltip from '../../components/Tooltip/AIEduTooltip';

const AdminSettings = ({
    f,
    formState,
    handleFormUpdate,
    handleChange,
    handleFormReset,
}) => {
    const [isEdit, setIsEdit] = useState(false);

    const updateForm = (e) => {
        e.preventDefault();

        handleFormUpdate();
        setIsEdit(false);
    };

    const handleEdit = (e) => {
        e.preventDefault();
        setIsEdit(true);
    };

    const resetForm = (e) => {
        e.preventDefault();
        handleFormReset();
        setIsEdit(false);
    };

    const userAccessTypeOptions = [
        {
            value: ROLE_USER,
            name: 'approvalRole',
            label: f({ id: 'AI_EDU_USER' }),
        },
        {
            value: ROLE_ADMIN,
            name: 'approvalRole',
            label: f({ id: 'AI_EDU_ADMIN' }),
        },
    ];

    return (
        <div className='mt-2'>
            <form>
                <div>
                    {isEdit ? (
                        <div className='flex gap-3'>
                            <AIEduButton
                                label={f({ id: 'AI_EDU_UPDATE_SETTINGS' })}
                                className={`btnPrimary`}
                                onClick={updateForm}
                            />
                            <AIEduButton
                                label={f({ id: 'AI_EDU_CANCEL' })}
                                className={`btnSecondary`}
                                onClick={resetForm}
                            />
                        </div>
                    ) : (
                        <AIEduButton
                            label={f({ id: 'AI_EDU_EDIT_SETTINGS' })}
                            severity='secondary'
                            className={`btnPrimary`}
                            icon='pi pi-pen-to-square'
                            onClick={handleEdit}
                        />
                    )}
                </div>
                <div className='flex justify-content-between align-items-center mt-4 mb-2'>
                    <div
                        className={`${styles.userAccessControl} ${styles.inputField}`}
                    >
                        {f({ id: 'AI_EDU_USER_ACCESS_CONTROLS' })}
                    </div>
                    <div className={styles.divider} style={{ width: '100%' }} />
                </div>
                <div className={styles.admin_settings_row1}>
                    <div className={styles.admin_settings_radio_btn}>
                        <span className={styles.admin_settings_label}>
                            {f({ id: 'AI_EDU_DEFAULT_USER_ACCESS_TYPE' })}
                        </span>
                        <AIEduRadioButton
                            name='approvalRole'
                            className={
                                styles.admin_settings_radiobutton_options
                            }
                            value={formState.approvalRole}
                            options={userAccessTypeOptions}
                            onChange={handleChange}
                            disabled={!isEdit}
                        />
                    </div>
                    <div className={styles.admin_settings_switch}>
                        <AIEduTooltip target='.user_request_approval' />
                        <div className='flex gap-2'>
                            <i
                                className='pi pi-info-circle user_request_approval'
                                data-pr-tooltip={f({ id: 'AI_EDU_AUTO_APPROVE_TOOLTIP' })}
                                data-pr-position='top'
                                style={{ fontSize: '20px', cursor: 'pointer' }}
                            />
                            <span className={styles.admin_settings_label}>
                                {f({ id: 'AI_EDU_AUTO_APPROVE_LOGIN_REQUEST' })}
                            </span>
                        </div>

                        <AIEduSwitch
                            name='approvalType'
                            checked={formState.approvalType}
                            onChange={handleChange}
                            disabled={!isEdit}
                        />
                    </div>
                </div>
                {/* <div
                    className="flex justify-content-between mt-3 mb-2"
                    style={{ width: "100%" }}
                >
                    <div>Device Access Controls</div>
                    <div
                        style={{
                            borderTop: "1px solid rgb(179, 179, 179)",
                            width: "86%",
                            height: "1px",
                            marginTop: "0.7rem",
                        }}
                    />
                </div>
                <div>
                    <div className={styles.admin_settings_row1}>
                        <div className={styles.admin_settings_switch}>
                            <span className={styles.admin_settings_label}>
                                Default Device Request Approval
                            </span>
                            <AIEduSwitch
                                name="deviceRequestApproval"
                                checked={formState.deviceRequestApproval}
                                onChange={handleChange}
                                disabled={!isEdit}
                            />
                        </div>
                    </div>
                </div> */}
            </form>
        </div>
    );
};

export default AdminSettings;
